import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import 'Components/Order/KeyReveals/Egg/EggReveal.scss';

function EggReveal({ setRevealStep }) {
  useEffect(() => {
    setTimeout(() => {
      setRevealStep(3);
    }, 8000);
  }, [setRevealStep]);

  return (
    <div className="EggReveal">
      <video
        autoPlay
        muted
        playsInline
        className="hero-background hero-video"
      >
        <source src="https://cdn.fanatical.com/production/assets/mystery/mystery-egg/2025/mystery-egg-video.mp4" type="video/mp4" />
      </video>
    </div>
  );
}

EggReveal.propTypes = {
  setRevealStep: PropTypes.func,
};

EggReveal.defaultProps = {
  setRevealStep: () => {},
};

export default EggReveal;
